import React, { FC, ReactElement } from 'react';

import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

import { ReactComponent as CloudArrowUpIcon } from 'assets/icons/CloudArrowUpIcon.svg';
import { ReactComponent as DisabledImageIcon } from 'assets/icons/DisabledImageIcon.svg';
import { ReactComponent as ErrorOutlinedInfoIcon } from 'assets/icons/ErrorOutlinedInfoIcon.svg';
import { ReactComponent as ImageIcon } from 'assets/icons/ImageIcon.svg';

import { Loader } from 'components/_basic/Loader/Loader';

import { IStatusProps as IProps } from './types';
import { DROPZONE_STATUS, IDropzoneStatus } from '../types';

import styles from './StatusDropzone.module.scss';

export const StatusDropzone: FC<IProps> = ({ message, status, isSmallDropzone = false }) => {
  const renderIconMap = new Map<IDropzoneStatus, ReactElement>([
    [DROPZONE_STATUS.default, <ImageIcon className={styles.statusImage} />],
    [DROPZONE_STATUS.disabled, <DisabledImageIcon className={styles.statusImage} />],
    [DROPZONE_STATUS.loading, <Loader color="primary" size={24} />],
    [DROPZONE_STATUS.error, <ErrorOutlinedInfoIcon className={styles.statusImage} />],
    [DROPZONE_STATUS.dragActive, <CloudArrowUpIcon className={styles.statusImage} />],
  ]);

  const getColor = () => {
    switch (status) {
      case DROPZONE_STATUS.disabled:
        return 'gray';
      case DROPZONE_STATUS.error:
        return 'error';
      default:
        return 'primary';
    }
  };

  return (
    <Box textAlign="center">
      <Box className={clsx(styles.statusImageWrapper, { [styles.small]: isSmallDropzone })}>
        {renderIconMap.get(status)}
      </Box>
      <Typography variant="subtitle2" color={getColor()}>
        {message}
      </Typography>
    </Box>
  );
};
